





















































































































































import { Component, Prop, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { defaultSystemCode, SystemCode } from '@/api'
import { systemCodeStore } from '@/utils/store-accessor'

export interface UpdateMemoInputInfoItem {
  workMemoCode: string
  workMemo: string
  workMemoTime: string
  workMemoBranchCode: SystemCode
  displayMemoCode: string
  displayMemo: string
  displayMemoTime: string
  displayMemoBranchCode: SystemCode
  localMemoCode: string
  localMemo: string
  localMemoTime: string
  localMemoBranchCode: SystemCode
}

export const defaultUpdateMemoInputInfoItem = (): UpdateMemoInputInfoItem => ({
  workMemoCode: '',
  workMemo: '',
  workMemoTime: '',
  workMemoBranchCode: defaultSystemCode(),
  displayMemoCode: '',
  displayMemo: '',
  displayMemoTime: '',
  displayMemoBranchCode: defaultSystemCode(),
  localMemoCode: '',
  localMemo: '',
  localMemoTime: '',
  localMemoBranchCode: defaultSystemCode()
})

@Component({
  components: {
    InputCode
  }
})
export default class UpdateMemoInputInfo extends ComponentVue {
  @Ref()
  workMemoInputCodeKey!: InputCode

  @Ref()
  displayMemoInputCodeKey!: InputCode

  @Ref()
  localMemoInputCodeKey!: InputCode

  @Prop({
    type: Object,
    default: defaultUpdateMemoInputInfoItem
  })
  item!: UpdateMemoInputInfoItem

  get exclusionCodesByWorkMemo(): string[] {
    return systemCodeStore.exclusionCodesByWorkMemo
  }

  get exclusionCodesByDisplayMemo(): string[] {
    return systemCodeStore.exclusionCodesByDisplayMemo
  }

  get exclusionCodesByLocalMemo(): string[] {
    return systemCodeStore.exclusionCodesByLocalMemo
  }

  focusWorkMemoInputCodeKey(): void {
    this.workMemoInputCodeKey.textField.atomTextField.focus()
  }

  focusDisplayMemoInputCodeKey(): void {
    this.displayMemoInputCodeKey.textField.atomTextField.focus()
  }

  focusLocalMemoInputCodeKey(): void {
    this.localMemoInputCodeKey.textField.atomTextField.focus()
  }

  onClickWorkMemoEraser(): void {
    this.item.workMemoCode = ''
    this.item.workMemo = ''
    this.item.workMemoTime = ''
    this.item.workMemoBranchCode = defaultSystemCode()
    this.focusWorkMemoInputCodeKey()
  }

  onClickDisplayMemoEraser(): void {
    this.item.displayMemoCode = ''
    this.item.displayMemo = ''
    this.item.displayMemoTime = ''
    this.item.displayMemoBranchCode = defaultSystemCode()
    this.focusDisplayMemoInputCodeKey()
  }

  onClickLocalMemoEraser(): void {
    this.item.localMemoCode = ''
    this.item.localMemo = ''
    this.item.localMemoTime = ''
    this.item.localMemoBranchCode = defaultSystemCode()
    this.focusLocalMemoInputCodeKey()
  }

  onInputWorkMemoCode(value: string): void {
    this.item.workMemoCode = value
    if (value === '') {
      this.item.workMemo = ''
      return
    }

    const systemCode:
      | SystemCode
      | undefined = systemCodeStore.getCollectionMemo.find(
      value => value.code === this.item.workMemoCode
    )
    if (systemCode) {
      this.item.workMemo = systemCode.name
    }
  }

  onInputDisplayMemoCode(value: string): void {
    this.item.displayMemoCode = value
    if (value === '') {
      this.item.displayMemo = ''
      return
    }

    const systemCode:
      | SystemCode
      | undefined = systemCodeStore.getCollectionMemo.find(
      value => value.code === this.item.displayMemoCode
    )
    if (systemCode) {
      this.item.displayMemo = systemCode.name
    }
  }

  onInputLocalMemoCode(value: string): void {
    this.item.localMemoCode = value
    if (value === '') {
      this.item.localMemo = ''
      return
    }

    const systemCode:
      | SystemCode
      | undefined = systemCodeStore.getCollectionMemo.find(
      value => value.code === this.item.localMemoCode
    )
    if (systemCode) {
      this.item.localMemo = systemCode.name
    }
  }
}
